<template>
  <div class="auth-layout-wrapper">
    <slot />
  </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue'

export default {
  name: 'AuthLayout',
  setup() {
    onMounted(() => {
      // Add authentication-bg class to body for proper styling
      document.body.classList.add('authentication-bg')
    })

    onUnmounted(() => {
      // Remove authentication-bg class when leaving auth pages
      document.body.classList.remove('authentication-bg')
    })
  }
}
</script>

<style scoped>
.auth-layout-wrapper {
  min-height: 100vh;
  width: 100%;
}
</style>

